/**
 * Lógica pura de roles/guardas. Sin React ni red: es la unidad testeable que
 * decide el acceso por rol. Los componentes de guarda la consumen.
 */
import type { Rol } from "../api/types.js";

export type { Rol } from "../api/types.js";

/** ¿Puede un usuario con `rol` entrar a una ruta que exige `permitidos`?
 *  Lista vacía = cualquier autenticado. `null` = anónimo (nunca pasa). */
export function puedeAcceder(rol: Rol | null, permitidos: readonly Rol[]): boolean {
  if (rol === null) return false;
  if (permitidos.length === 0) return true;
  return permitidos.includes(rol);
}

/** Ruta de inicio según rol (a dónde mandar tras login o desde "/"). */
export function rutaInicioPorRol(rol: Rol): string {
  switch (rol) {
    case "padre":
      return "/padre";
    case "terapeuta":
      return "/terapeuta";
    case "admin":
      return "/admin";
  }
}
